module.exports = __webpack_public_path__ + "img/5-4.dc3149c6.svg";